import { FeaturedUsedProduct, UsedProductsFeatureds } from "@/@types";
import { UsedProductsFeaturedsResponse } from "../usedProduct/models/UsedProductFeaturedResponse";

export function mapUsedProductsFeatureds(featured: UsedProductsFeaturedsResponse[]): UsedProductsFeatureds[] {
    return featured.map((item) => ({
        listName: item.list_name,
        featuredUsedProducts: item.featured_used_products.map((product) => ({
            image: product.image,
            model: product.model,
            year: product.year,
            slug: product.slug,
        })),
    }));
}
